import "./productTableStyle.css"

export default function ProductTable ({specifications}) {

    return (
        <table className="product-table">
            {specifications?.map( (item, index) => (
                <tr key={index} className="product-table__row">
                    <th className="product-table__header">
                        {item.specification}
                    </th>
                    <td className="product-table__value">
                        {item.value}
                    </td>
                </tr>
            ))}
        </table>
    );
}